import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from './types';

export const determineState = (assessment: DashboardQuery['assessment']): AssessmentState => {
  const scenarios = assessment?.scenarios;
  if (!scenarios?.length) return 'NO_SCENARIOS';

  const hasAnyControls = scenarios.some((s) => s.riskManagementPlans?.length > 0);
  if (!hasAnyControls) return 'SCENARIOS_NO_CONTROLS';

  const hasModifiers = scenarios.some((s) => s.riskManagementPlans?.some((rmp) => rmp.modifiers?.length > 0));
  if (!hasModifiers) return 'SCENARIOS_CONTROLS_NO_MODIFIERS';

  const hasLiveControls = scenarios.some((s) => s.riskManagementPlans?.some((rmp) => rmp.control?.status === 'Live'));
  const hasPendingControls = scenarios.some((s) =>
    s.riskManagementPlans?.some((rmp) => ['In Progress', 'Not Started'].includes(rmp.control?.status || '')),
  );

  if (hasLiveControls && hasPendingControls) return 'ALL_INFO_AVAILABLE';
  if (hasLiveControls) return 'SCENARIOS_LIVE_CONTROLS_MODIFIERS';
  return 'SCENARIOS_PENDING_CONTROLS_MODIFIERS';
};

export const getStateWarningMessage = (state: AssessmentState, html?: boolean) => {
  switch (state) {
    case 'NO_SCENARIOS':
      return !html
        ? 'This assessment does not contain any risk scenarios.'
        : 'This assessment does not <br/>contain any risk scenarios.';
    case 'SCENARIOS_NO_CONTROLS':
      return !html
        ? 'This assessment does not have any linked controls.'
        : 'This assessment does not <br/>have any linked controls.';
    case 'SCENARIOS_CONTROLS_NO_MODIFIERS':
      return !html
        ? 'This assessment does not have any linked controls with modifiers.'
        : 'This assessment does not <br/>have any linked controls with modifiers.';
    default:
      return '';
  }
};
